<template>
  <div class="table">
    <div class="table_top">
      <div class="table_top_L">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="类型">
            <el-select v-model="formInline.type" placeholder="类型" clearable>
              <el-option label="赛事推荐位" :value="0"></el-option>
              <el-option label="赛事瞬间" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="formInline.id" placeholder="标题"></el-input>
          </el-form-item>
          <el-form-item label="联赛id">
            <el-select v-model="formInline.contestId" placeholder="联赛id" clearable filterable>
              <el-option v-for="option in tableData1" :key="option.value" :label="option.label" :value="option.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="inquire">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="openAddDialog">新增赛事推荐</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="openContestConfigDialog">新增赛事简介</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table
      :data="tableData"
      width="10%"
      height="100%"
      border
      stripe
      highlight-current-row
      v-loading="listLoading"
      ref="table"
      current-row-key="id"
      row-key="id"
      key="id"
      column-key="id"
      @selection-change="selectionChange"
    >
      <el-table-column prop="contestId" label="联赛id" width="60"></el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          {{ scope.row.type == 0 ? '赛事推荐位' : '赛事瞬间' }}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column label="图片">
        <template slot-scope="scope">
          <img :src="scope.row.img" alt="" style="height: 50px; width: auto;" />
        </template>
      </el-table-column>
      <el-table-column prop="jumpLink" label="跳转链接"></el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="danger" size="small" @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增对话框 -->
    <el-dialog title="新增赛事推荐" :visible.sync="addDialogVisible">
      <el-form :model="newBanner" ref="addForm">
        <el-form-item label="跳转链接">
          <el-radio-group v-model="newBanner.type">
            <el-radio :label="0">赛事推荐位</el-radio>
            <el-radio :label="1">赛事瞬间</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标题" prop="title" required>
          <el-input v-model="newBanner.title"></el-input>
        </el-form-item>

        <el-form-item label="联赛id" prop="contestId" required>
          <el-select v-model="newBanner.contestId" placeholder="选择联赛id" clearable>
            <el-option v-for="option in tableData1" :key="option.value" :label="option.label" :value="option.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片" prop="img">
          <div v-loading="isLoading" element-loading-text="正在上传...">
            <img v-if="uploadUrl" :src="uploadUrl" style="height:100px;width:100px;" />
            <input type="file" @change="handleFileChange" ref="fileInput" />
          </div>
        </el-form-item>

        <el-form-item label="跳转链接" prop="jumpLink">
          <el-input v-model="newBanner.jumpLink" placeholder="跳转链接"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBanner">取 消</el-button>
        <el-button type="primary" @click="addNewBanner">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增赛事简介对话框 -->
    <el-dialog title="新增赛事简介" :visible.sync="contestConfigDialogVisible" width="60%">
      <div class="contest-config-container">
        <div v-for="(item, index) in contestConfigList" :key="index" class="config-item">
          <!-- <div class="config-item-header">
            <span>配置项 {{ index + 1 }}</span>
            <el-button type="danger" size="small" @click="removeConfigItem(index)" v-if="contestConfigList.length > 1">删除</el-button>
          </div> -->
          <div class="config-item-content">
            <div class="config-row-four">
              <!-- 第一列：类型选择下拉框 -->
              <div class="config-column type-selector">
                <p style="white-space: nowrap;">类型：</p>
                <el-select v-model="item.type" placeholder="选择类型" @change="handleTypeChange(index)">
                  <el-option label="图片" :value="1"></el-option>
                  <el-option label="文本" :value="2"></el-option>
                  <el-option label="时间" :value="3"></el-option>
                </el-select>
              </div>

              <!-- 第二列：key输入框 -->
              <div class="config-column key-column">
                <p style="white-space: nowrap;">key值：</p>
                <el-input v-model="item.keyData" placeholder="请输入key" clearable></el-input>
              </div>

              <!-- 第三列：根据类型动态显示对应组件 -->
              <div class="config-column component-area">
                <!-- 图片类型 -->
                <div v-if="item.type === 1" class="image-component">
                  <img
                    v-if="item.valueData"
                    :src="'https://boyubasketball.oss-cn-shanghai.aliyuncs.com/' + item.valueData"
                    class="preview-image"
                  />
                  <input type="file" @change="handleConfigFileChange($event, index)" :ref="`configFileInput${index}`" />
                </div>

                <!-- 文本类型 -->
                <div v-if="item.type === 2" class="text-component">
                  <el-input v-model="item.valueData" placeholder="请输入内容" type="textarea" :rows="3" style="width: 100%;"> </el-input>
                </div>

                <!-- 时间类型 -->
                <div v-if="item.type === 3" class="time-component">
                  <el-date-picker v-model="item.valueData" type="datetime" placeholder="选择时间" value-format="yyyy-MM-dd HH:mm:ss">
                  </el-date-picker>
                </div>
              </div>

              <!-- 第四列：删除按钮 -->
              <div class="config-column action-buttons">
                <el-button
                  type="danger"
                  size="small"
                  @click="removeConfigItem(index)"
                  v-if="contestConfigList.length > 1"
                  icon="el-icon-delete"
                >
                  删除
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="config-actions">
          <el-button type="primary" @click="addConfigItem">增加配置项</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeContestConfigDialog">取 消</el-button>
        <el-button type="primary" @click="saveContestConfig">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addBanner, bannerList, delBanner, contestListDown, uploadPhoto, contestConfigDataList, addContestConfigData } from '@/api/table'

export default {
  data() {
    return {
      tableData1: [],
      tableData: [],
      listLoading: true,
      form: {
        contestId: '',
        img: '',
        jumpLink: '',
        title: ''
      },
      formInline: {
        id: '',
        contestId: '',
        state: '',
        type: ''
      },
      newBanner: {
        // 新增的 Banner 数据
        title: '',
        contestId: '',
        img: '',
        jumpLink: '',
        type: 0
      },
      uploadUrl: '',
      isLoading: false,
      uploadHeaders: {
        Authorization: '' // 替换为你的鉴权令牌
      },
      total: 0, // 添加总条数
      addDialogVisible: false, // 控制视频弹窗的显示与隐藏
      videoList: [], // 存储视频列表数据
      previewImage: '', // 用于存储预览图片的 URL
      showPreview: false, // 控制预览对话框的显示
      contestConfigDialogVisible: false, // 控制赛事简介弹窗的显示与隐藏
      contestConfigList: [] // 存储赛事简介配置数据
    }
  },
  mounted() {
    this.reqData1()
    this.tableData = this.reqData()
    this.listLoading = false
  },
  methods: {
    async handleFileChange(event) {
      const file = event.target.files[0]
      if (!file) return

      this.isLoading = true // 开始加载

      // 使用 FileReader 来读取文件并生成预览图
      const fileReader = new FileReader()
      fileReader.onload = temp => {
        this.uploadUrl = temp.target.result
      }
      fileReader.readAsDataURL(file)

      const formData = new FormData()
      formData.append('file', file) // 'file' 为后端接收的字段名

      try {
        const response = await uploadPhoto(formData)
        console.log(response)
        this.newBanner.img = response.msg
        this.$message.success('图片上传成功！')
      } catch (error) {
        this.$message.error('图片上传失败！')
      } finally {
        this.isLoading = false // 上传完成，结束加载
      }
    },

    openAddDialog() {
      this.addDialogVisible = true // 打开对话框
      this.resetNewBanner() // 重置表单数据
      this.$refs.fileInput.value = null
    },
    closeBanner() {
      this.addDialogVisible = false
      this.uploadUrl = ''
      this.$refs.fileInput.value = null
    },
    resetNewBanner() {
      this.newBanner = {
        title: '',
        contestId: '',
        img: '',
        jumpLink: '',
        type: 0
      }
    },
    inquire() {
      this.reqData(1, 10000, {
        title: this.formInline.title,
        state: this.formInline.state,
        contestId: this.formInline.contestId,
        type: this.formInline.type
      })
    },
    inquire1() {
      this.reqData(1, 10000, {
        contestId: this.newBanner.contestId
      })
    },
    selectionChange(selection) {
      this.selectionLength = selection.length
    },
    async addNewBanner() {
      await addBanner(this.newBanner)
      this.addDialogVisible = false
      this.uploadUrl = ''
      this.inquire1()
    },
    // 请求
    reqData(pageNum = 1, pageSize = 10000, query = {}) {
      const params = { pageNum, pageSize, ...query }
      bannerList(params).then(async res => {
        const promises = res.rows.map(async item => {
          // 根据需要拼接 URL
          item.img = `https://boyubasketball.oss-cn-shanghai.aliyuncs.com/${item.img}`
          return item
        })
        this.tableData = await Promise.all(promises)
      })
    },
    reqData1(pageNum = 1, pageSize = 10000, query = {}) {
      const params = { pageNum, pageSize, ...query }
      contestListDown(params).then(res => {
        this.tableData1 = res.data.map(item => ({
          value: item.id,
          label: item.name // 假设 id 是数字类型
        }))
      })
    },
    async del(id) {
      try {
        await delBanner(id)
        this.inquire()
      } catch (e) {
        alert('删除失败')
      }
    },

    // 赛事简介相关方法
    async openContestConfigDialog() {
      await this.loadContestConfigData()
    },

    closeContestConfigDialog() {
      this.contestConfigDialogVisible = false
      this.resetContestConfigList()
    },

    async loadContestConfigData() {
      if (!this.formInline.contestId) {
        this.$message.error('请选择联赛id')
        return
      }
      try {
        const response = await contestConfigDataList({
          contestId: this.formInline.contestId
        })
        this.contestConfigDialogVisible = true
        if (response && response.data && response.data) {
          // 将接口返回的数据转换为弹窗需要的格式
          this.contestConfigList = response.data
          // 如果接口没有返回数据，默认添加一个空配置项
          if (this.contestConfigList.length === 0) {
            this.contestConfigList = [this.createEmptyConfigItem()]
          }
        } else {
          // 如果接口返回格式不符合预期，默认添加一个空配置项
          this.contestConfigList = [this.createEmptyConfigItem()]
        }
      } catch (error) {
        console.error('加载赛事简介数据失败:', error)
        this.$message.error('加载赛事简介数据失败')
        // 出错时默认添加一个空配置项
        this.contestConfigList = [this.createEmptyConfigItem()]
      }
    },

    createEmptyConfigItem() {
      return {
        type: 1, // 默认选择图片类型：1-图片, 2-文本, 3-时间
        keyData: '', // 新增keyData字段
        valueData: '', // 统一的数据字段
        contestId: this.formInline.contestId
      }
    },

    detectTypeFromData(item) {
      // 根据数据自动检测类型
      if (item.img) return 1 // 图片
      if (item.inputValue) return 2 // 文本
      if (item.time) return 3 // 时间
      return 1 // 默认返回图片类型
    },

    getValueDataFromItem(item) {
      // 根据数据类型从接口数据中提取对应的值
      if (item.img) return item.img
      if (item.inputValue) return item.inputValue
      if (item.time) return item.time
      return ''
    },

    handleTypeChange(index) {
      // 当类型改变时，清空统一的数据字段
      const item = this.contestConfigList[index]
      item.valueData = ''

      // 如果是图片类型，还需要清空图片相关字段
      // if (item.type === 1) {
      //   // 图片
      //   item.img = ''
      //   item.imgPreview = ''
      // }
    },

    resetContestConfigList() {
      this.contestConfigList = []
    },

    addConfigItem() {
      this.contestConfigList.push(this.createEmptyConfigItem())
    },

    removeConfigItem(index) {
      this.contestConfigList.splice(index, 1)
    },

    async handleConfigFileChange(event, index) {
      const file = event.target.files[0]
      if (!file) return

      // this.contestConfigList[index].isLoading = true

      // 使用 FileReader 来读取文件并生成预览图
      // const fileReader = new FileReader()
      // fileReader.onload = temp => {
      //   this.contestConfigList[index].imgPreview = temp.target.result
      // }
      // fileReader.readAsDataURL(file)

      const formData = new FormData()
      formData.append('file', file)

      try {
        const response = await uploadPhoto(formData)
        this.contestConfigList[index].img = response.msg
        this.contestConfigList[index].valueData = response.msg // 同时保存到统一数据字段
        this.$message.success('图片上传成功！')
      } catch (error) {
        this.$message.error('图片上传失败！')
      } finally {
        // this.contestConfigList[index].isLoading = false
      }
    },

    async saveContestConfig() {
      try {
        console.log('测试内容：', JSON.parse(JSON.stringify(this.contestConfigList)))
        // 这里需要根据实际接口要求处理数据
        // const configData = this.contestConfigList.map(item => ({
        //   key: item.keyData,
        //   type: item.type,
        //   valueData: item.valueData,
        //   img: item.type === 1 ? item.img : '' // 只有图片类型才需要img字段
        // }))

        // TODO: 调用保存接口，需要根据实际接口调整
        // await saveContestConfig(configData)
        // 1-图片  2 文本输入框 3 日期
        await addContestConfigData(this.contestConfigList)
        this.$message.success('赛事简介保存成功！')
        this.closeContestConfigDialog()
      } catch (error) {
        console.error('保存赛事简介失败:', error)
        this.$message.error('保存赛事简介失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  display: flex;
  flex-flow: column;
  box-sizing: border-box;

  .table_top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;

    .table_top_L {
      text-align-last: left;
      flex: 1;
      overflow: hidden;
    }
  }

  .table_bottom {
    margin-top: 10px;
  }

  height: 100%;
}
</style>
<style>
.table .el-table {
  transition: all ease-in-out 0.3s;
}

.table .el-table td,
.table .el-table th {
  text-align: center;
}

.table .el-dialog {
  text-align: left;
}

.table .el-dialog .line {
  text-align: center;
}

.el-image-viewer__close {
  background-color: #fff;
}

/* 重新覆盖原来的样式，原来的样式是.el-drawer获取焦点时的outline */
.el-image-viewer__wrapper:focus {
  outline: none;
}

/* 赛事简介弹窗样式 */
.contest-config-container {
  max-height: 500px;
  overflow-y: auto;
}

.config-item {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 10px 20px;
  margin-bottom: 10px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.config-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.config-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e8f4fd;
}

.config-item-header span {
  font-weight: 600;
  color: #1890ff;
  font-size: 16px;
}

.config-item-content {
  padding: 0;
}

/* 四列布局样式 */
.config-row-four {
  display: grid;
  grid-template-columns: 180px 200px 1fr 120px;
  gap: 16px;
  align-items: center;
}

.config-column {
  display: flex;
  align-items: center;
  /* height: 100%; */
}

/* 类型选择器样式 */
.type-selector label {
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  font-size: 14px;
}

.type-selector .el-select {
  width: 100%;
}

/* Key列样式 */
.key-column label {
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  font-size: 14px;
}

.key-column .el-input {
  width: 100%;
}

/* 组件区域样式 */
.component-area {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  padding: 16px;
  background-color: #fafbfc;
  transition: all 0.3s ease;
}

.component-area:hover {
  border-color: #1890ff;
  background-color: #f0f7ff;
}

/* 图片组件样式 */
.image-component {
  width: 100%;
  text-align: center;
}

.preview-image {
  height: 100px;
  width: auto;
  max-width: 200px;
  border: 2px solid #e4e7ed;
  border-radius: 6px;
  margin-bottom: 12px;
  object-fit: cover;
}

.image-component input[type='file'] {
  margin-top: 8px;
  padding: 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: white;
  cursor: pointer;
}

/* 时间组件样式 */
.time-component {
  width: 100%;
}

.time-component .el-date-editor {
  width: 100%;
}

/* 文本组件样式 */
.text-component {
  width: 100%;
}

/* 操作按钮区域样式 */
.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.action-buttons .el-button {
  width: 100px;
}

.config-actions {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px solid #e8f4fd;
}

.config-actions .el-button {
  padding: 12px 24px;
  font-size: 14px;
}
</style>
